/* global ssws_verksamheter_images */
/* eslint-disable quotes */

export default {
  init() {
    // JavaScript to be fired on all pages
    console.log("nytida-website common.js LOADED");

    /* SEARCH */
    var $search = $("header.banner .search-form");

    $search.submit(function (e) {
      if ($(window).width() >= 992) {
        return true;
      }

      e.preventDefault();
      $search.toggleClass("open");
      let $input = $search.find(".search-field");
      $input.focus();
    });

    if ($('[data-toggle="popover"]').length) {
      /*ENABLE POPOVERS ON SITE*/
      $('[data-toggle="popover"]').popover();
      $("body").on("click", function (e) {
        if (
          !e.target.closest('.popover[role="tooltip"]') &&
          !e.target.getAttribute("data-toggle")
        ) {
          $('[data-toggle="popover"]').popover("hide");
        }
        if (e.target.getAttribute("data-toggle") === "popover") {
          $(
            ".popover:not(#" + e.target.getAttribute("aria-describedby") + ")",
          ).popover("hide");
        }
      });
    }

    if (jQuery(".scmb-thumbnail").length) {
      jQuery(".scmb-thumbnail").each(function () {
        jQuery(this).children("img").attr("alt", "");
      });
    }

    $(document).ready(function () {
      setTimeout(function () {
        $(".slick-prev").attr("aria-label", "Föregående");
        $(".slick-next").attr("aria-label", "Nästa");
      }, 100);
      if (
        typeof ssws_verksamheter_images !== "object" ||
        ssws_verksamheter_images.length === 0
      ) {
        return;
      }
      $(document).on("keydown", function (event) {
        if (event.key !== "Escape") {
          return;
        }
        $("body").removeClass("all-images-modal-body--open");
        $(".vertical-gallery-view").hide();
      });
      $(".absolute-container, .single-visa-alla-bilder").click(function () {
        $(".vertical-gallery-view").show();
        $("body").addClass("all-images-modal-body--open");
        $(".all-images").scrollTop(0);
        let current_slide = $(this).data("key");
        if (!current_slide) {
          current_slide = $(".carousel-item.active [data-key]").data("key");
        }
        if (
          $(
            ".all-images-modal__content--all-images .all-images__image-container",
          ).length === 0
        ) {
          $(".all-images-modal__content--all-images .all-images__list").html(
            "",
          );
          for (let x = 0; x < ssws_verksamheter_images.length; x++) {
            let link = "";
            if (
              typeof ssws_verksamheter_images[x].large === "object" &&
              typeof ssws_verksamheter_images[x].large.source_url === "string"
            ) {
              link = ssws_verksamheter_images[x].large.source_url;
            }
            if (
              link === "" &&
              typeof ssws_verksamheter_images[x].medium_large === "object" &&
              typeof ssws_verksamheter_images[x].medium_large.source_url ===
                "string"
            ) {
              link = ssws_verksamheter_images[x].medium_large.source_url;
            }
            if (
              link === "" &&
              typeof ssws_verksamheter_images[x].ssws_verks_gallery ===
                "object" &&
              typeof ssws_verksamheter_images[x].ssws_verks_gallery
                .source_url === "string"
            ) {
              link = ssws_verksamheter_images[x].ssws_verks_gallery.source_url;
            }
            if (
              link === "" &&
              typeof ssws_verksamheter_images[x].medium === "object" &&
              typeof ssws_verksamheter_images[x].medium.source_url === "string"
            ) {
              link = ssws_verksamheter_images[x].medium.source_url;
            }
            if (
              link === "" &&
              typeof ssws_verksamheter_images[x].thumbnail === "object" &&
              typeof ssws_verksamheter_images[x].thumbnail.source_url ===
                "string"
            ) {
              link = ssws_verksamheter_images[x].thumbnail.source_url;
            }
            if (link === "") {
              //no valid images found in the set
              continue;
            }
            let is_active = current_slide === x ? " active" : "";
            $(
              ".all-images-modal__content--all-images .all-images__list",
            ).append(
              `<div class="all-images__image-container${is_active}" data-key="${x}"><img src="${link}" alt=""></div>`,
            );
          }
        } else {
          $(
            ".all-images-modal__content--all-images .all-images__list .active",
          ).removeClass("active");
          $(
            `.all-images-modal__content--all-images .all-images__list [data-key="${current_slide}"]`,
          ).addClass("active");
        }
        setTimeout(function () {
          let posTop = $(".all-images__image-container.active").offset().top;
          if (posTop !== 0) {
            $(".all-images").animate({ scrollTop: posTop }, 100);
          }
        }, 200);
      });
      $(document).on(
        "click",
        ".fullscreen-action-bar__close-button",
        function () {
          $("body").removeClass("all-images-modal-body--open");
          $(".vertical-gallery-view").hide();
        },
      );
      setInterval(function () {
        let item_index = $(".carousel-item.active").index();
        if (typeof item_index === "number") {
          $(".single-picture-count .current").text(item_index);
        }
      }, 100);
      $(".carousel").carousel("pause");
      $("#ssws_contract_frm-modal input.search-field").on(
        "input change",
        function () {
          let search = $(this).val();
          if (search === "") {
            $(
              "#ssws_contract_frm-modal .list-unstyled li.ssws_contract_dscr",
            ).show();
            $("#ssws_contract_frm-modal .ssws-contract-loc-wrap").show();
            return;
          }
          $("#ssws_contract_frm-modal .ssws-contract-loc-wrap").hide();
          let search_regexp = new RegExp(search, "i");
          $(
            "#ssws_contract_frm-modal .list-unstyled .ssws-contract-loc-wrap",
          ).each(function () {
            try {
              if ($(this).find("h4").text().match(search_regexp)) {
                $(this).show();
                $(this).find("li.ssws_contract_dscr").show();
                return;
              }
              $(this)
                .find("li.ssws_contract_dscr")
                .each(function () {
                  if ($(this).text().match(search_regexp)) {
                    $(this).show();
                    $(this).parents(".ssws-contract-loc-wrap").show();
                  } else {
                    $(this).hide();
                  }
                });
            } catch (ex) {
              return;
            }
          });
        },
      );
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
